//shared/context/auth-context
import { createContext } from "react";

export const AuthContext = createContext({
  isLoggedIn: false,
  userId: null,
  token: null,
  image: null,
  role: null,
  listaRoles: null,
  estabelecimento: null,
  login: () => {},
  logout: () => {},
  atualizarEstabelecimento: () => {},
});
